<template>
	<b-col sm="2" md="2" lg="1" class="pt-3" :order="order">
		<b-button variant="primary" size="sm" type="submit" class="text-nowrap" :class="$CoreSettingsJs.isMobile() ? `btn-icon` : ``">
			<b-icon-search></b-icon-search>
			<span v-show="!$CoreSettingsJs.isMobile()" v-text="$t('COMMON.BTN_SEARCH')"></span>
		</b-button>
	</b-col>
</template>

<script>
export default {
	name: "SearchButton",
	props: {
		hasPermission: false,
		order: 0
	}
};
</script>
